import { useCallback, useMemo } from 'react'
import styled from 'styled-components'

import { FlexDivColCentered } from 'components/layout/flex'
import useWindowSize from 'hooks/useWindowSize'
import { selectShowBanner } from 'state/app/selectors'
import { selectPerpsProvider } from 'state/futures/common/selectors'
import { setTradePanelDrawerOpen } from 'state/futures/reducer'
import { selectShowSwitchNetwork } from 'state/futures/selectors'
import { PerpsProvider } from 'state/futures/types'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { selectWallet } from 'state/wallet/selectors'
import media from 'styles/media'

import MarketDetails from '../MarketDetails/MarketDetails'
import FuturesUnsupportedNetwork from '../Trade/FuturesUnsupported'
import TradeBalanceCrossMargin from '../Trade/TradeBalanceCrossMargin'
import TradeBalance from '../Trade/TradeBalanceSmartMargin'

import TradePanelDrawer from './drawers/TradePanelDrawer'
import OverviewTabs from './OverviewTabs'
import UserTabs from './UserTabs'

const MobileTrade: React.FC = () => {
	const { deviceType } = useWindowSize()
	const showBanner = useAppSelector(selectShowBanner)
	const futuresType = useAppSelector(selectPerpsProvider)
	const showNetworkPrompt = useAppSelector(selectShowSwitchNetwork)
	const tradeDrawerPanelOpen = useAppSelector(({ futures }) => futures.tradePanelDrawerOpen)
	const walletAddress = useAppSelector(selectWallet)
	const dispatch = useAppDispatch()

	const handleCloseDrawer = useCallback(() => {
		dispatch(setTradePanelDrawerOpen(false))
	}, [dispatch])

	const balanceInfo = useMemo(() => {
		return futuresType === PerpsProvider.SNX_V3 ? <TradeBalanceCrossMargin /> : <TradeBalance />
	}, [futuresType])

	return (
		<>
			<MobileContainer mobile={deviceType === 'mobile'} id="mobile-view" showBanner={showBanner}>
				<MarketDetails mobile />
				{deviceType === 'mobile' && walletAddress && balanceInfo}
			</MobileContainer>
			<OverviewTabs />
			{showNetworkPrompt ? (
				<SwitchNetworkContainer>
					<FuturesUnsupportedNetwork />
				</SwitchNetworkContainer>
			) : (
				<UserTabs />
			)}
			{tradeDrawerPanelOpen && (
				<TradePanelDrawer open={tradeDrawerPanelOpen} closeDrawer={handleCloseDrawer} />
			)}
		</>
	)
}

const MobileContainer = styled.div<{ mobile: boolean; showBanner: boolean }>``

const SwitchNetworkContainer = styled(FlexDivColCentered)`
	justify-content: center;
	margin-top: 100px;
	${media.lessThan('md')`
		margin-top: 30px;
	`}
`

export default MobileTrade
